import type { CodingScreenState } from '../../project_starburst/interface';
import {
  type ProcessInstanceGate,
  transactionsFromProcessInstance
} from './stateMappers/transactionsFromProcessInstance';

export const injectTransactions = (
  state: CodingScreenState,
  gate: ProcessInstanceGate,
  permission: 'allowed' | 'denied' | undefined,
  scope: string | undefined
): CodingScreenState => {
  if (!state) return state;
  return {
    ...state,
    values: {
      ...state.values,
      'case.transactions': {
        ...transactionsFromProcessInstance(gate),
        ...(permission && { permission }),
        ...(scope && { scope }),
        ...(gate.revision !== undefined && { revision: gate.revision })
      }
    }
  };
};
